// Who gets pinged when a new merchant application needs a look — hardcoded
// per explicit product direction rather than a DB-backed recipient list,
// same reasoning as admin/src/app/auth/dev-switcher-emails.constants.ts.
// Only the plans that actually queue for review (see AuthService.
// registerMerchant's AUTO_APPROVE_PLANS) trigger this — an auto-approved
// signup needs no one to log in and approve/reject it.
export const MERCHANT_REVIEW_NOTIFICATION_EMAILS: readonly string[] = [
  'sudharshanreddyjanike@gmail.com',
  'sagar.sdnsoftech@gmail.com',
];
